<template>
  <Submenu v-if="item.visible && item.children && item.children.length" :name="item.id">
    <!-- 创建父级菜单 -->
    <template slot="title">
      <Icon v-if="item.icon" :custom="item.icon" size="14"></Icon>
      <span class="layout-text">{{ item.title }}</span>
    </template>
    <!-- 创建子菜单 -->
    <aside-item v-for="(subItem,index) in item.children" :item="subItem" :name="subItem.id" :key="'c'+index"></aside-item>
  </Submenu>
  <MenuItem :name="item.id" v-else-if="item.visible">
    <Icon v-if="item.icon" :custom="item.icon"></Icon>
    <span class="layout-text">{{ item.title }}</span>
  </MenuItem>
</template>
<script>
export default {
  name: 'AsideItem',
  props: ['item'],
}

</script>
